<template>
  <div class="">
    <v-tabs v-model="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{ tab.title }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "SanadTabs",
  data() {
    return {};
  },
  props: {
    type: {
      default: null
    },
  },
  mounted() {
  },
  computed: {
    selectedTab() {
      if (this.$route.name == 'SanadForm') {
        return 0
      }
      if (this.$route.name == 'SanadsList' && this.type == 'all') {
        return 1
      }
      if (this.$route.name == 'SanadsList'  && this.type == 'unbalanced') {
        return 2
      }
      if (this.$route.name == 'SanadsList'  && this.type == 'empty') {
        return 3
      }
      if (this.$route.name == 'SanadsList'  && this.type == 'notDefined') {
        return 4
      }
      if (this.$route.name == 'SanadItemsList') {
        return 5
      }
    },
    tabs() {
      return [
        {title: 'ثبت سند', key: 'form'},
        {title: 'اسناد حسابداری', key: 'list', type: 'all'},
        {title: 'اسناد نامتوازن', key: 'list', type: 'unbalanced'},
        {title: 'اسناد خالی', key: 'list', type: 'empty'},
        {title: 'اسناد غیر قطعی', key: 'list', type: 'notDefined'},
        {title: 'جزئیات اسناد', key: 'itemList'},
      ]
    },
  },
  methods: {
    changeRoute(tab) {
      if(tab.key == 'form'){
        this.$router.push('/panel/sanad/form')
      }
      else if (tab.key == 'list' && tab.type == 'all'){
        this.$router.push('/report/lists/sanads')
      }
      else if (tab.key == 'list'){
        this.$router.push('/report/lists/sanads/' + tab.type)
      }
      else if (tab.key == 'itemList'){
        this.$router.push('/report/lists/sanadItems')
      }
    }
  }

};
</script>

<style scoped lang="scss">
</style>

